/* eslint-disable no-console */
import React, { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  CotizadorProgrammaticCalculadora,
  CotizadorProgrammaticDuracion,
  CotizadorProgrammaticFrecuencia,
  CotizadorProgrammaticHorasOn,
  CotizadorProgrammaticInventario,
  CotizadorProgrammaticPlazo,
} from "../../components";
import "./stylesOnlineCotizador.scss";

export const CotizadorProgrammatic = () => {
  const location = useLocation();
  const simuladorConfig = location.state?.simuladorConfig || null;

  const [inventarioData, setInventarioData] = useState({
    ascensoresSeleccionados: 0,
    audienciaSeleccionadaAscensor: 0,
    audienciaSeleccionadaCowork: 0,
    audienciaSeleccionadaEspera: 0,
    audienciaSeleccionadaTotal: 0,
    audienciaSeleccionadaTotems: 0,
    coworkSeleccionados: 0,
    edificiosSeleccionadosAscensores: [],
    edificiosSeleccionadosCowork: [],
    edificiosSeleccionadosTotems: [],
    edificiosSeleccionadosEspera: [],
    esperaSeleccionados: 0,
    totemsSeleccionados: 0,
  });
  const [plazo, setPlazo] = useState(0);
  const [frecuencia, setFrecuencia] = useState("");
  const [horasSeleccionadas, setHorasSeleccionadas] = useState({
    horas: 0,
    intervalos: [],
    options: [],
  });
  const [duracion, setDuracion] = useState(0);
  const [isProgrammaticSelected, setIsProgrammaticSelected] = useState(false);
  const [isDigitalSelected, setIsDigitalSelected] = useState(false);
  const [resetInventario, setResetInventario] = useState(false);
  const [includeInstallingBuildings, setIncludeInstallingBuildings] = useState(false);
  const [resetCounter, setResetCounter] = useState(0); // Nuevo contador de reseteo

  // Procesar configuración del simulador si viene de allí
  useEffect(() => {
    if (simuladorConfig) {
      console.log("Cargando configuración del simulador:", simuladorConfig);
      // Configurar modo Digital (el simulador siempre es digital)
      setIsDigitalSelected(simuladorConfig.isDigitalSelected || true);
      setIsProgrammaticSelected(simuladorConfig.isProgrammaticSelected || false);
      // Configurar parámetros de campaña
      if (simuladorConfig.plazo) setPlazo(simuladorConfig.plazo);
      if (simuladorConfig.frecuencia) setFrecuencia(simuladorConfig.frecuencia);
      if (simuladorConfig.duracion) setDuracion(simuladorConfig.duracion);
      if (simuladorConfig.horasSeleccionadas) setHorasSeleccionadas(simuladorConfig.horasSeleccionadas);
    }
  }, [simuladorConfig]);

  const handleProgrammaticChange = (isProgrammatic) => {
    setIsProgrammaticSelected(isProgrammatic);
    setIsDigitalSelected(!isProgrammatic);
    setResetInventario(true);
    setInventarioData({
      ascensoresSeleccionados: 0,
      audienciaSeleccionadaAscensor: 0,
      audienciaSeleccionadaCowork: 0,
      audienciaSeleccionadaEspera: 0,
      audienciaSeleccionadaTotal: 0,
      audienciaSeleccionadaTotems: 0,
      coworkSeleccionados: 0,
      edificiosSeleccionadosAscensores: [],
      edificiosSeleccionadosCowork: [],
      edificiosSeleccionadosTotems: [],
      edificiosSeleccionadosEspera: [],
      esperaSeleccionados: 0,
      totemsSeleccionados: 0,
    });
    setHorasSeleccionadas({ horas: 0, intervalos: [], options: [] });
    setPlazo(0);
    setFrecuencia("");
    setDuracion(0);
    setResetCounter((prev) => prev + 1); // Incrementar el contador de reseteo
  };

  const handleDigitalChange = (isDigital) => {
    setIsDigitalSelected(isDigital);
    setIsProgrammaticSelected(!isDigital);
    setResetInventario(true);
    setInventarioData({
      ascensoresSeleccionados: 0,
      audienciaSeleccionadaAscensor: 0,
      audienciaSeleccionadaCowork: 0,
      audienciaSeleccionadaEspera: 0,
      audienciaSeleccionadaTotal: 0,
      audienciaSeleccionadaTotems: 0,
      coworkSeleccionados: 0,
      edificiosSeleccionadosAscensores: [],
      edificiosSeleccionadosCowork: [],
      edificiosSeleccionadosTotems: [],
      edificiosSeleccionadosEspera: [],
      esperaSeleccionados: 0,
      totemsSeleccionados: 0,
    });
    setHorasSeleccionadas({ horas: 0, intervalos: [], options: [] });
    setPlazo(0);
    setFrecuencia("");
    setDuracion(0);
    setResetCounter((prev) => prev + 1); // Incrementar el contador de reseteo
  };

  const handleResetInventarioComplete = () => {
    setResetInventario(false);
  };

  const handleSubmitInventario = useCallback((data) => {
    setInventarioData(data);
  }, []);

  const handlePlazoChange = useCallback((numberOfDays) => {
    setPlazo(numberOfDays);
  }, []);

  const handleFrecuenciaChange = useCallback((selectedFrecuencia) => {
    setFrecuencia(selectedFrecuencia);
  }, []);

  const handleHorasChange = useCallback((totalHours, selectedIntervals, selectedOptions = []) => {
    setHorasSeleccionadas({ horas: totalHours, intervalos: selectedIntervals, options: selectedOptions });
  }, []);

  const handleDuracionChange = useCallback((selectedDuracion) => {
    setDuracion(selectedDuracion);
  }, []);

  const handleIncludeInstallingBuildingsChange = (isChecked) => {
    setIncludeInstallingBuildings(isChecked);
    setResetInventario(true);
  };

  const selectedOption =
    horasSeleccionadas.options.length > 0
      ? horasSeleccionadas.options[0].label
      : horasSeleccionadas.intervalos.length > 0
        ? "INTERVALOS"
        : "";

  return (
    <div className="online-cotizador-wrapper">
      <CotizadorProgrammaticCalculadora
        inventarioData={inventarioData}
        plazo={plazo}
        frecuencia={frecuencia}
        horasSeleccionadas={horasSeleccionadas}
        duracion={duracion}
        isProgrammaticSelected={isProgrammaticSelected}
        onIncludeInstallingBuildingsChange={handleIncludeInstallingBuildingsChange}
      />
      <div className="controls-container">
        <div className="controls-row">
          <CotizadorProgrammaticHorasOn
            onHorasChange={handleHorasChange}
            onProgrammaticChange={handleProgrammaticChange}
            onDigitalChange={handleDigitalChange}
            onOptionChange={(option) =>
              handleHorasChange(horasSeleccionadas.horas, horasSeleccionadas.intervalos, [{ label: option }])
            }
            isProgrammaticSelected={isProgrammaticSelected}
            isDigitalSelected={isDigitalSelected}
            defaultHoras={simuladorConfig?.horasSeleccionadas?.horas || 0}
            defaultIntervalos={simuladorConfig?.horasSeleccionadas?.intervalos || []}
            defaultOptions={simuladorConfig?.horasSeleccionadas?.options || []}
            simuladorConfig={simuladorConfig}
          />
          <CotizadorProgrammaticInventario
            onSubmit={handleSubmitInventario}
            isProgrammaticSelected={isProgrammaticSelected}
            resetInventario={resetInventario}
            onResetComplete={handleResetInventarioComplete}
            includeInstallingBuildings={includeInstallingBuildings}
            defaultEdificiosAscensores={simuladorConfig?.edificiosSeleccionados?.ascensores}
            defaultEdificiosTotems={simuladorConfig?.edificiosSeleccionados?.totems}
            defaultEdificiosEspera={simuladorConfig?.edificiosSeleccionados?.espera}
            defaultEdificiosCowork={simuladorConfig?.edificiosSeleccionados?.cowork}
          />
          <CotizadorProgrammaticPlazo
            onPlazoChange={handlePlazoChange}
            plazo={plazo}
            defaultPlazo={simuladorConfig?.plazo}
            resetCounter={resetCounter}
          />
          <CotizadorProgrammaticFrecuencia
            onFrecuenciaChange={handleFrecuenciaChange}
            isProgrammaticSelected={isProgrammaticSelected}
            isDigitalSelected={isDigitalSelected}
            selectedOption={selectedOption}
            horasSeleccionadas={horasSeleccionadas.horas}
            frecuencia={frecuencia}
            defaultFrecuencia={simuladorConfig?.frecuencia}
            plazo={plazo}
            resetCounter={resetCounter}
          />
          <CotizadorProgrammaticDuracion
            onDuracionChange={handleDuracionChange}
            duracion={duracion}
            defaultDuracion={simuladorConfig?.duracion}
            resetCounter={resetCounter}
          />
        </div>
      </div>
    </div>
  );
};
